<template lang="html">
  <div class="mark-paper">
    <div class="mark-paper__header">
      <div class="title">画笔批改</div>
      <div class="buttons">
        <el-button @click="quit">退出批改</el-button>
        <el-button type="primary" @click="saveCanvas">保存</el-button>
      </div>
    </div>
    <div class="mark-paper__container">
      <div class="mark-paper__thumb">
        <el-scrollbar class="mark-paper__scroll">
        <ul>
          <li v-for="(item, i) in fillImageList" :key="item.id" @click="changeCanvas(i)" :class="{active: i === selectIndex}">
            <span class="order" :class="{active: i === selectIndex}">{{i + 1}}</span>
            <span class="thumb__img"><img :src="item.src"></span>
          </li>
        </ul>
        </el-scrollbar>
      </div>
      <div class="mark-paper__wrap">
        <div class="canvas__wrap" ref="wrap" id="canvas__wrap">
          <canvas id="canvas"></canvas>
        </div>
        <div class="tools">
          <div class="scale_canvas">
            <el-select v-model="scaleValue" @change="handleZoom" size="small" popper-class="customSelect">
              <el-option
                v-for="item in scaleOpts"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <span class="tag">缩放</span>
          </div>
          <div class="tools_box">
            <span @click="changeMode(MOVE_MODE)">
              <i class="icon move" :class="{active: CURRENT_MODE === MOVE_MODE}"></i>
              <i class="tag">移动</i>
            </span>
            <span @click="changeMode(PAINT_MODE)">
              <i class="icon paint" :class="{active: CURRENT_MODE === PAINT_MODE}"></i>
              <i class="tag">画笔</i>
            </span>
            <span @click="changeMode(ERASER_MODE)">
              <i class="icon eraser" :class="{active: CURRENT_MODE === ERASER_MODE}"></i>
              <i class="tag">橡皮擦</i>
            </span>
            <!-- <span @click="changeMode(LINE_MODE)">
              <i class="icon line"></i>
              <i class="tag">划线</i>
            </span>
            <span @click="changeMode(ARROW_MODE)">
              <i class="icon arrow"></i>
              <i class="tag">箭头</i>
            </span>
            <span @click="changeMode(RECT_MODE)">
              <i class="icon rect"></i>
              <i class="tag">方框</i>
            </span> -->
            <el-popover
              placement="bottom"
              v-model="visible"
              popper-class="customPopover"
              trigger="click">
              <div>
                <ul class="colors">
                  <li @click="changeColor(i)" v-for="(color, i) in colors" :key="i" :class="{active: lineColorIndex === i}"><span :style="{backgroundColor: color}"></span></li>
                </ul>
              </div>
              <span @click="changeMode(LINE_MODE)"  slot="reference">
                  <i class="icon line" :class="{active: CURRENT_MODE === LINE_MODE}" style="border-right: solid 1px #e5e5e5;"></i>
                  <i class="tag">划线</i>
                </span>
            </el-popover>
            <el-popover
              placement="bottom"
              v-model="visible1"
              popper-class="customPopover"
              trigger="click">
              <div>
                <ul class="colors">
                  <li @click="changeColor(i)" v-for="(color, i) in colors" :key="i" :class="{active: arrowColorIndex === i}"><span :style="{backgroundColor: color}"></span></li>
                </ul>
              </div>
              <span @click="changeMode(ARROW_MODE)"  slot="reference">
                  <i class="icon arrow" :class="{active: CURRENT_MODE === ARROW_MODE}" style="border-right: solid 1px #e5e5e5;"></i>
                  <i class="tag">箭头</i>
                </span>
            </el-popover>
            <el-popover
              placement="bottom"
              v-model="visible2"
              popper-class="customPopover"
              trigger="click">
              <div>
                <ul class="colors">
                  <li @click="changeColor(i)" v-for="(color, i) in colors" :key="i" :class="{active: rectColorIndex === i}"><span :style="{backgroundColor: color}"></span></li>
                </ul>
              </div>
              <span @click="changeMode(RECT_MODE)"  slot="reference">
                  <i class="icon rect" :class="{active: CURRENT_MODE === RECT_MODE}" style="border-right: solid 1px #e5e5e5;"></i>
                  <i class="tag">方框</i>
                </span>
            </el-popover>
            <el-popover
              placement="bottom"
              v-model="visible3"
              popper-class="customPopover"
              trigger="click">
              <div>
                <ul class="colors">
                  <li @click="changeColor(i)" v-for="(color, i) in colors" :key="i" :class="{active: tagColorIndex === i}"><span :style="{backgroundColor: color}"></span></li>
                </ul>
              </div>
              <span @click="changeMode(TAG_MODE)"  slot="reference">
                  <i class="icon tag" :class="{active: CURRENT_MODE === TAG_MODE}" style="border-right: solid 1px #e5e5e5;"></i>
                  <i class="tag">标签</i>
                </span>
            </el-popover>
            <!-- <span @click="changeMode(TAG_MODE)">
              <i class="icon tag"></i>
              <i class="tag">标签</i>
            </span> -->
            <span @click="changeMode(HIGHLIGHT_MODE)">
              <i class="icon highlight" :class="{active: CURRENT_MODE === HIGHLIGHT_MODE}"></i>
              <i class="tag">高亮</i>
            </span>
            <span @click="changeMode(COMMENTS_MODE)">
              <i class="icon comments" :class="{active: CURRENT_MODE === COMMENTS_MODE}"></i>
              <i class="tag">批注</i>
            </span>
          </div>
          <div class="handle_box">
            <span @click="handleRotate">
              <i class="icon rotate"></i>
              <i class="tag">旋转</i>
            </span>
            <span @click="handleUndo">
              <i class="icon cancel"></i>
              <i class="tag">撤销</i>
            </span>
            <span @click="clearCanvas">
              <i class="icon clear"></i>
              <i class="tag">清空样式</i>
            </span>
          </div>
        </div>
        <!-- 附件 -->
        <div class="attachments" v-if="attachmentListData && attachmentListData.length > 0">
          <div class="left attachments-title">附件：</div>
          <div class="left" v-for="(item, index) in attachmentListData" :key="index">
            <span v-if="item.type === 3 || item.type === 4 || item.type === 5" @click="viewAttachment(item.content)" class="attachmentIcon pic" :class="[attachmentType[item.type]]" slot="reference"></span>
          </div>
        </div>
        <!-- <button @click="save">保存</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getURLBase64 } from '@/utils/getURLBase64'
const attachmentList = require('./mock.json')
// type: 作答内容类型, 1: 文字, 2: 批注, 3: 视频, 4: 音频, 5: 文档(包括word、pdf、压缩包等)
export default {
  data () {
    return {
      attachmentListData: [],
      attachmentType: [
        '',
        '',
        '',
        'video',
        'audio',
        'other'
      ],
      canvas: null,
      context: null,
      CURRENT_MODE: 0,
      MOVE_MODE: 0,
      PAINT_MODE: 1,
      ERASER_MODE: 2,
      LINE_MODE: 3,
      ARROW_MODE: 4,
      RECT_MODE: 5,
      RECT_MODE2: 11,
      TAG_MODE: 6,
      HIGHLIGHT_MODE: 7,
      COMMENTS_MODE: 8,
      tagList: [
        './img/1.png',
        './img/2.png',
        './img/3.png'
      ],
      currentTagIndex: 0,
      fillImageSrc: '',
      currentCanvasObj: [],
      currentIndex: 0,
      currentAngle: 0,
      bgScale: {
        scaleX: 1,
        scaleY: 1
      },
      scaleOpts: [
        {
          value: 0.5,
          label: '50%'
        },
        {
          value: 0.75,
          label: '75%'
        },
        {
          value: 1,
          label: '100%'
        },
        {
          value: 1.25,
          label: '125%'
        },
        {
          value: 1.5,
          label: '150%'
        },
        {
          value: 1.75,
          label: '175%'
        },
        {
          value: 2,
          label: '200%'
        }
      ],
      scaleValue: 1,
      bgOptions: {},
      originList: [
        {
          originX: 'left',
          originY: 'top'
        },
        {
          originX: 'left',
          originY: 'bottom'
        },
        {
          originX: 'right',
          originY: 'bottom'
        },
        {
          originX: 'right',
          originY: 'top'
        }
      ],
      fillImageList: [
        {
          id: 1,
          canvasObj: [],
          originSrc: 'https://s.eoffcn.com/pigai/admin/img/202008/IG8VHtgPrvzsHkK9LvOmgqzSTNllFH4fmiNqkCyO.jpeg',
          src: 'http://cdn.algbb.cn/test/canvasTest.jpg',
          rotate: 0
        },
        {
          id: 2,
          canvasObj: [],
          originSrc: 'http://cdn.algbb.cn/test/canvasTest2.png',
          src: 'http://cdn.algbb.cn/test/canvasTest2.png',
          rotate: 0
        },
        {
          id: 3,
          canvasObj: [],
          originSrc: 'http://cdn.algbb.cn/emoji/30.png',
          src: 'http://cdn.algbb.cn/emoji/30.png',
          rotate: 0
        }
        // {
        //   id: 4,
        //   canvasObj: [],
        //   originSrc: '1.png',
        //   src: '1.png'
        // }
      ],
      visible: false,
      visible1: false,
      visible2: false,
      visible3: false,
      isDrawingMode: false,
      mouseTo: {
        x: undefined,
        y: undefined
      },
      mouseFrom: {
        x: undefined,
        y: undefined
      },
      doDrawing: false,
      drawingObject: null,
      selectIndex: 0,
      fillStartPointX: 0,
      fillStartPointY: 0,
      colors: [
        '#ff3300',
        '#00ccff',
        '#66ff00',
        '#ffff00',
        '#666666',
        '#ffffff'
      ],
      lineColorIndex: 0,
      arrowColorIndex: 0,
      rectColorIndex: 0,
      tagColorIndex: 0,
      drawWidth: 2,
      tagNumList: [],
      tagColorsName: [
        'red',
        'blue',
        'green',
        'yellow',
        'grey',
        'white'
      ],
      lastZoom: 1,
      undo: [],
      state: undefined,
      undoStatus: false
    }
  },
  methods: {
    // 初始化canvas对象
    init (flag) {
      this.wrap = document.getElementById('canvas__wrap')
      this.wrap.style.cursor = 'move'
      // 设置canvas样式
      const canvasWidth = window.getComputedStyle(this.$refs.wrap).width.slice(0, -2)
      const canvasHeight = window.getComputedStyle(this.$refs.wrap).height.slice(0, -2)
      this.c = document.getElementById('canvas')
      this.context = this.c.getContext('2d')

      this.c.width = canvasWidth
      this.c.height = canvasHeight

      if (flag === 'zoom') {

      } else {
        this.handleCanvas(0)
      }
    },
    // 初始化canvas
    async handleCanvas (index) {
      this.CURRENT_MODE = this.MOVE_MODE
      this.currentIndex = index
      this.fillImageSrc = this.fillImageList[index].originSrc
      this.currentCanvasObj = this.fillImageList[index].canvasObj

      // 获取远程图片的宽高
      this.img = new Image()
      this.img.setAttribute('crossOrigin', 'Anonymous')
      this.img.src = await getURLBase64(this.fillImageSrc)
      console.log(1)
      this.img.onload = () => {
        console.log(this.img.width, this.img.height)
        // 新建一个canvas实例
        if (!this.canvas) {
          this.canvas = new fabric.Canvas('canvas', {
            backgroundColor: 'white'
          })
          this.canvas.defaultCursor = `move`
          this.handleEventListener()
        } else {
          this.canvas.clear()
        }
        this.isDrawingMode = false
        this.canvas.isDrawingMode = this.isDrawingMode
        this.canvas.defaultCursor = `move`
        this.canvas.hoverCursor = `move`
        this.canvas.skipTargetFind = false

        let { scaleX, scaleY } = this.bgScale
        let translateLeft = (this.canvas.width - this.img.width) / 2
        let translateTop = (this.canvas.height - this.img.height) / 2
        if (this.img.width > (this.canvas.width - 280) || this.img.height > (this.canvas.height - 480)) {
          scaleX = (this.canvas.width - 280) / this.img.width
          scaleY = (this.canvas.width - 280) / this.img.width
          translateLeft = (this.canvas.width - this.img.width * scaleX) / 2
          translateTop = (this.canvas.height - this.img.height * scaleX) / 2
        }
        this.bgOptions = {
          top: translateTop,
          left: translateLeft,
          scaleX: scaleX,
          scaleY: scaleY,
          // width: this.canvas.width,
          // height: this.canvas.height,
          originX: 'left',
          originY: 'top',
          angle: 0
        }

        this.canvas.setBackgroundImage(
          // this.fillImageSrc,
          this.img.src,
          // this.img,
          this.canvas.renderAll.bind(this.canvas),
          this.bgOptions
        )
        // 遍历标注数组
        this.tagNumList = new Array(20).fill(false)
        if (this.currentCanvasObj.length > 0) {
          this.currentCanvasObj.forEach((item) => {
            this.canvas.add(item)
            if (item.customType === 'tag') {
              this.tagNumList[item.index] = true
            }
          })
        }
        setTimeout(() => {
          this.undo = []
          this.undo.push(this.canvas.toJSON())
          console.log(this.undo)
        }, 1000)
      }
    },
    // 保存状态
    saveState () {
      // if (this.state) {
      //   this.undo.push(this.state)
      // }
      this.state = this.canvas.toJSON()
      this.undo.push(this.state)
      console.log('undo::', this.undo)
      // this.undo.push(this.state)
      console.log("state--->   ", this.state)
    },
    // 撤销
    handleUndo () {
      this.undoStatus = true
      console.log(this.undo.length)
      console.log(this.undo)
      if (this.undo.length === 1) {
        return
      }
      if (this.undo.length === 2) {
        this.state = this.undo[0]
        console.log(this.state)
        this.undo.splice(this.undo.length - 1, 1)
        this.canvas.clear()
        this.canvas.loadFromJSON(this.state, () => {
          this.canvas.renderAll()
        })
        return
      }
      this.state = this.undo.splice(this.undo.length - 2, 1)
      console.log(this.undo)
      console.log(this.state)
      // if (this.state[0].objects[this.state[0].objects.length - 1])
      if (this.state) {
        // this.canvas.clear()
        this.canvas.loadFromJSON(this.state[0], () => {
          this.canvas.renderAll()
        })
      }
    },
    // 切换缩略图
    changeCanvas (index) {
      this.selectIndex = index
      // 保存切换前的数据
      this.fillImageList[this.currentIndex].canvasObj = this.canvas.getObjects()
      console.log(this.fillImageList)
      this.handleCanvas(index)
    },
    drawArrow (fromX, fromY, toX, toY, theta, headlen) {
      theta = typeof theta !== 'undefined' ? theta : 30
      headlen = typeof theta !== 'undefined' ? headlen : 10
      // 计算各角度和对应的P2,P3坐标
      var angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI
      var angle1 = (angle + theta) * Math.PI / 180
      var angle2 = (angle - theta) * Math.PI / 180
      var topX = headlen * Math.cos(angle1)
      var topY = headlen * Math.sin(angle1)
      var botX = headlen * Math.cos(angle2)
      var botY = headlen * Math.sin(angle2)
      var arrowX = fromX - topX
      var arrowY = fromY - topY
      var path = ' M ' + fromX + ' ' + fromY
      path += ' L ' + toX + ' ' + toY
      arrowX = toX + topX
      arrowY = toY + topY
      path += ' M ' + arrowX + ' ' + arrowY
      path += ' L ' + toX + ' ' + toY
      arrowX = toX + botX
      arrowY = toY + botY
      path += ' L ' + arrowX + ' ' + arrowY
      return path
    },
    transformMouse(mouseX, mouseY) {
      return { x: mouseX, y: mouseY };
    },
    drawing () {
      if (this.drawingObject) {
        this.canvas.remove(this.drawingObject);
      }
      var canvasObject = null
      switch (this.CURRENT_MODE) {
        case this.LINE_MODE:
          console.log(this.mouseFrom.x)
          let tt = (750 * this.scaleValue / 2 - this.mouseFrom.x) / this.scaleValue * (this.scaleValue - 1) + this.mouseFrom.x
          console.log(tt)
          let t = this.mouseFrom.x * this.scaleValue
          canvasObject = new fabric.Line([this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y], {
            stroke: this.colors[this.lineColorIndex],
            strokeWidth: this.drawWidth,
            scaleValue: this.scaleValue
          })
          break
        case this.HIGHLIGHT_MODE:
          canvasObject = new fabric.Line([this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y], {
            stroke: 'rgba(255,255,0, 0.3)',
            strokeWidth: 15,
            scaleValue: this.scaleValue
          })
          break
        case this.ARROW_MODE:
          canvasObject = new fabric.Path(this.drawArrow(this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y, 30, 30), {
            stroke: this.colors[this.arrowColorIndex],
            fill: 'rgba(255,255,255,0)',
            strokeWidth: this.drawWidth,
            scaleValue: this.scaleValue
          })
          break
        case this.RECT_MODE:
          var path =
            'M ' +
            this.mouseFrom.x +
            ' ' +
            this.mouseFrom.y +
            ' L ' +
            this.mouseTo.x +
            ' ' +
            this.mouseFrom.y +
            ' L ' +
            this.mouseTo.x +
            ' ' +
            this.mouseTo.y +
            ' L ' +
            this.mouseFrom.x +
            ' ' +
            this.mouseTo.y +
            ' L ' +
            this.mouseFrom.x +
            ' ' +
            this.mouseFrom.y +
            ' z'
          canvasObject = new fabric.Path(path, {
            left: this.mouseFrom.x,
            top: this.mouseFrom.y,
            stroke: this.colors[this.rectColorIndex],
            strokeWidth: this.drawWidth,
            fill: 'rgba(255, 255, 255, 0)',
            scaleValue: this.scaleValue
          })
          break
      }

      this.canvas.add(canvasObject)
      this.drawingObject = canvasObject
    },
    changeMode (mode) {
      this.undoStatus = false
      this.CURRENT_MODE = mode
      switch (mode) {
        case this.MOVE_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `move`
          this.canvas.hoverCursor = `move`

          this.canvas.skipTargetFind = false
          // this.canvas.selectable = true
          // this.canvas.selection = true

          break
        case this.PAINT_MODE:
          this.isDrawingMode = true
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.freeDrawingBrush.color = 'red'
          this.canvas.freeDrawingBrush.width = 2 * this.scaleValue
          this.canvas.defaultCursor = `url('http://cdn.algbb.cn/pencil.ico') 6 26, pointer`
          this.canvas.hoverCursor = `url('http://cdn.algbb.cn/pencil.ico') 6 26, pointer`
          this.paintScale = this.scaleValue
          break
        case this.ERASER_MODE:
          this.canvas.discardActiveObject()
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          // this.canvas.freeDrawingBrush.color = null
          // this.canvas.freeDrawingBrush.width = 0

          this.canvas.selection = true
          this.canvas.skipTargetFind = false
          this.canvas.selectable = true

          this.canvas.defaultCursor = `url('http://cdn.algbb.cn/eraser.ico') 6 26, pointer`
          this.canvas.hoverCursor = `url('http://cdn.algbb.cn/eraser.ico') 6 26, pointer`
          break
        case this.LINE_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `crosshair`
          this.canvas.hoverCursor = `crosshair`
          this.canvas.skipTargetFind = true
          this.canvas.selectable = false
          this.canvas.selection = false
          break
        case this.ARROW_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `crosshair`
          this.canvas.hoverCursor = `crosshair`
          this.canvas.skipTargetFind = true
          this.canvas.selectable = false
          this.canvas.selection = false
          break
        case this.RECT_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `crosshair`
          this.canvas.hoverCursor = `crosshair`
          this.canvas.skipTargetFind = true
          this.canvas.selectable = false
          this.canvas.selection = false
          break
        case this.HIGHLIGHT_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `crosshair`
          this.canvas.hoverCursor = `crosshair`
          this.canvas.skipTargetFind = true
          this.canvas.selectable = false
          this.canvas.selection = false
          break
        case this.TAG_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `default`
          this.canvas.hoverCursor = `default`
          this.canvas.skipTargetFind = true
          this.canvas.selectable = false
          this.canvas.selection = false
          break
        case this.COMMENTS_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `default`
          this.canvas.hoverCursor = `default`
          break
        default:
          break
      }
    },
    // 清除
    onlyClearCanvas () {
      let thisCanvasObj = this.canvas.getObjects()
      if (thisCanvasObj.length === 0) {
        return
      }
      if (thisCanvasObj.length > 0) {
        thisCanvasObj.forEach((item) => {
          this.canvas.remove(item)
        })
      }
    },
    // 清除
    clearCanvas () {
      let thisCanvasObj = this.canvas.getObjects()
      if (thisCanvasObj.length === 0) {
        return
      }
      this.$confirm('确定要清空所有样式吗？历史编辑也会被清空', '', {
        confirmButtonText: '清空样式',
        cancelButtonText: '继续编辑',
        type: 'warning'
      }).then(() => {
        // 遍历标注数组
        if (thisCanvasObj.length > 0) {
          thisCanvasObj.forEach((item) => {
            this.canvas.remove(item)
          })
        }
        this.$message({
          type: 'success',
          message: '清除成功!'
        })
      }).catch(() => {

      })
    },
    // 旋转
    handleRotate () {
      if (this.currentAngle === 270) {
        this.currentAngle = 0
      } else {
        this.currentAngle += 90
      }
      const { originX, originY } = this.originList[this.currentAngle / 90]
      this.bgOptions.originX = originX
      this.bgOptions.originY = originY
      this.bgOptions.angle = this.currentAngle
      this.canvas.setBackgroundImage(
        // this.fillImageSrc,
        this.img.src,
        this.canvas.renderAll.bind(this.canvas),
        this.bgOptions
      )
    },
    // 缩放
    handleZoom (value) {
      this.drawWidth = 2 * value
      document.getElementById('canvas__wrap').style.width = (750 * value) + 'px'
      document.getElementById('canvas__wrap').style.marginLeft = -(750 * value) / 2 + 'px'
      document.getElementById('canvas__wrap').style.height = (1334 * value) + 'px'

      const c = this.canvas.getObjects()
      this.canvas.clear()
      console.log(c)
      this.canvas.dispose()
      console.log(this.canvas)
      this.canvas = null
      this.init('zoom')
      this.canvas = new fabric.Canvas('canvas', {
        backgroundColor: 'white'
      })
      this.handleEventListener()

      let { scaleX, scaleY } = this.bgScale
      let translateLeft = (this.canvas.width - this.img.width) / 2
      let translateTop = (this.canvas.height - this.img.height) / 2
      if (this.img.width > (this.canvas.width - 280 * this.scaleValue) || this.img.height > (this.canvas.height - 480 * this.scaleValue)) {
        scaleX = (this.canvas.width - 280 * this.scaleValue) / this.img.width
        scaleY = (this.canvas.width - 280 * this.scaleValue) / this.img.width
        translateLeft = (this.canvas.width - this.img.width * scaleX) / 2
        translateTop = (this.canvas.height - this.img.height * scaleX) / 2
      }
      this.bgOptions = {
        top: translateTop,
        left: translateLeft,
        scaleX: scaleX,
        scaleY: scaleY,
        // width: this.canvas.width,
        // height: this.canvas.height,
        originX: 'left',
        originY: 'top',
        angle: 0
      }

      this.canvas.setBackgroundImage(
        // this.fillImageSrc,
        this.img.src,
        this.canvas.renderAll.bind(this.canvas),
        this.bgOptions
      )

      c.forEach((item) => {
        // item.scale((1 / this.lastZoom) * this.scaleValue)
        // item.scale(1 / item.scaleValue * this.scaleValue)
        item.top = item.top / this.lastZoom * this.scaleValue
        item.left = item.left / this.lastZoom * this.scaleValue
        if (item.customType !== 'tag' && item.stroke !== 'red' && item.type !== 'textbox') {
          item.scale(this.scaleValue / item.scaleValue)
        } else if (item.stroke === 'red') {
          // 缩放计算不准
          item.scaleX = this.scaleValue / this.paintScale
          item.scaleY = this.scaleValue / this.paintScale
          item.strokeWidth = 2 * this.scaleValue
          console.log('ooooooooo', item)
          item.path.map((onePath) => {
            for (let i = 1; i < onePath.length; i++) {
               onePath[i] = onePath[i] * (this.scaleValue / this.paintScale)
            }
            // onePath[1] = onePath[1] * (this.scaleValue / this.paintScale)
            // onePath[2] = onePath[2] * (this.scaleValue / this.paintScale)
          })
          console.log('qqqqqqqqqqqq', item)
        }
        this.canvas.add(item)
      })
      this.canvas.renderAll()
      console.log(this.canvas.getObjects())
      // this.canvas.setZoom(value)
      this.lastZoom = value
      this.paintScale = value
      console.log(window.getComputedStyle(this.$refs.wrap).width.slice(0, -2))
      // this.canvas.style.transform = `scale(1.5)`
      // const zoomX = this.canvas.width / 2
      // const zoomY = (this.canvas.height) / 2
      // let zoomPoint = new fabric.Point(zoomX, zoomY)
      // this.canvas.zoomToPoint(zoomPoint, value)
    },
    // 事件监听
    handleEventListener () {
      this.canvas.on('object:modified', () => {
        console.log('modified')
        this.saveState()
      })
      this.canvas.on('object:added', () => {
        console.log(this.undoStatus)
        if (this.undoStatus || this.CURRENT_MODE === this.LINE_MODE || this.CURRENT_MODE === this.ARROW_MODE || this.CURRENT_MODE === this.RECT_MODE || this.CURRENT_MODE === this.HIGHLIGHT_MODE) {
          console.log('return')
          return
        }
        console.log('add')
        this.saveState()
      })
      this.canvas.on('object:removed', () => {
        console.log('removed')
        if (this.CURRENT_MODE === this.LINE_MODE || this.CURRENT_MODE === this.ARROW_MODE || this.CURRENT_MODE === this.RECT_MODE || this.CURRENT_MODE === this.HIGHLIGHT_MODE) {
          return
        }
        this.saveState()
      })
      this.canvas.on('object:rotating', () => {
        console.log('rotating')
        this.saveState()
      })
      // 监听滚轮放大缩小
      document.addEventListener('mousewheel', (e) => {
        // if (e.target.className === 'upper-canvas ') {
        //   console.log(this.canvas.getZoom())
        //   let zoom = (event.deltaY > 0 ? -0.25 : 0.25) + this.canvas.getZoom()
        //   if (zoom > 2) {
        //     zoom = 2
        //   } else if (zoom < 0.5) {
        //     zoom = 0.5
        //   }
        //   this.scaleValue = zoom
        //   console.log(zoom)
        //   zoom = Math.max(0.5, zoom) // 最小为原来的1/2
        //   zoom = Math.min(2, zoom) // 最大是原来的2倍
        //   this.zoom = zoom
        //   // let zoomPoint = new fabric.Point(event.pageX, event.pageY)
        //   const zoomX = this.canvas.width / 2
        //   const zoomY = (this.canvas.height) / 2
        //   let zoomPoint = new fabric.Point(zoomX, zoomY)
        //   this.canvas.zoomToPoint(zoomPoint, zoom)
        // }

        // this.scaleValue = (event.deltaY > 0 ? -0.25 : 0.25) + this.scaleValue
        // this.handleZoom(this.scaleValue)
      })
      // 鼠标按下事件

      // wrap.onmousedown = (e) => {
      //   if (this.CURRENT_MODE === 0) {
      //     this.panning = true
      //     this.canvas.selection = false

      //     this.downX = e.pageX
      //     this.downY = e.pageY
      //     wrap.onmousemove = (event) => {
      //       this.moveX = event.pageX
      //       this.moveY = event.pageY
      //       this.translatePointX = this.fillStartPointX + (this.moveX - this.downX)
      //       this.translatePointY = this.fillStartPointY + (this.moveY - this.downY)
      //       wrap.style.transform = `translate(${this.translatePointX}px,${this.translatePointY}px)`
      //     }
      //     wrap.onmouseup = (event) => {
      //       if (this.CURRENT_MODE === 0) {
      //         this.upX = event.pageX
      //         this.upY = event.pageY
      //         this.fillStartPointX = this.fillStartPointX + (this.upX - this.downX)
      //         this.fillStartPointY = this.fillStartPointY + (this.upY - this.downY)
      //         // wrap.onmousemove = null
      //         // wrap.onmouseup = null

      //       }
      //     }
      //   }

      // }
      this.canvas.on('mouse:down', (e) => {
        console.log(e.target)
        console.log('down')
        if (this.CURRENT_MODE === 0 && !e.target) {
          this.panning = true
          this.canvas.selection = false

          this.downX = e.e.pageX
          this.downY = e.e.pageY
        } else if (this.CURRENT_MODE === this.LINE_MODE || this.CURRENT_MODE === this.ARROW_MODE || this.CURRENT_MODE === this.RECT_MODE || this.CURRENT_MODE === this.HIGHLIGHT_MODE) {
          this.panning = false
          let xy = this.transformMouse(e.e.offsetX, e.e.offsetY)
          this.mouseFrom.x = xy.x
          this.mouseFrom.y = xy.y
          this.doDrawing = true
        } else if (this.CURRENT_MODE === this.COMMENTS_MODE) {
          let xy = this.transformMouse(e.e.offsetX, e.e.offsetY)
          let textbox = new fabric.Textbox(' ', {
            left: xy.x,
            top: xy.y,
            width: 240,
            height: 140,
            fontSize: 14,
            borderColor: '#fff390',
            editingBorderColor: '#fff390',
            border: 1,
            hasBorders: true,
            fill: '#b79a3d',
            hasControls: false,
            selection: true,
            selectable: true,
            skipTargetFind: false,
            backgroundColor: '#fefbc5'
          })
          this.canvas.add(textbox)
          this.canvas.setActiveObject(textbox)
        } else if (this.CURRENT_MODE === this.TAG_MODE) {
          let ifMaximum = this.tagNumList.every((bool) => {
              return bool === true
          })
          if (ifMaximum) {
            this.$message({
              message: '标签数已达到上限',
              type: 'warning'
            })
            return
          }
          let currentTagNum = 0
          for (let i = 0; i < this.tagNumList.length; i++) {
            if (!this.tagNumList[i]) {
              currentTagNum = i
              this.tagNumList[i] = true
              break
            }
          }
          let xy = this.transformMouse(e.e.offsetX, e.e.offsetY)
          const tagImg = `./img/${this.tagColorsName[this.tagColorIndex]}/${currentTagNum + 1}.png`
          fabric.Image.fromURL(require(`${tagImg}`), (img) => {
            let oImg = img.set({
              left: xy.x - 10,
              top: xy.y - 10,
              hasControls: false,
              customType: 'tag',
              index: currentTagNum
            }).scale(0.5)
            this.canvas.add(oImg)
            // setTimeout(() => {
            //   this.saveState()
            // }, 200)
            console.log(this.canvas.getObjects())
            // if (this.currentTagIndex < this.tagList.length) {
            //   this.currentTagIndex++
            // }
          })
        }
      })
      // 移动画布事件
      this.canvas.on('mouse:move', (e) => {
        if (this.CURRENT_MODE === 0 && this.panning && !e.target) {
          this.moveX = e.e.pageX
          this.moveY = e.e.pageY
          this.translatePointX = this.fillStartPointX + (this.moveX - this.downX)
          this.translatePointY = this.fillStartPointY + (this.moveY - this.downY)
          this.wrap.style.transform = `translate(${this.translatePointX}px,${this.translatePointY}px)`
        } else if (this.CURRENT_MODE === this.LINE_MODE || this.CURRENT_MODE === this.ARROW_MODE || this.CURRENT_MODE === this.RECT_MODE || this.CURRENT_MODE === this.HIGHLIGHT_MODE) {
          if (!this.doDrawing) {
            // 减少绘制频率
            return
          }
          // moveCount++;
          var xy = this.transformMouse(e.e.offsetX, e.e.offsetY)
          this.mouseTo.x = xy.x
          this.mouseTo.y = xy.y
          this.drawing()
        }
      })
      // 鼠标抬起事件
      this.canvas.on('mouse:up', (e) => {
        this.undoStatus = false
        this.panning = false
        // this.canvas.selection = true
        if (this.CURRENT_MODE === 0 && !e.target) {
          this.upX = e.e.pageX
          this.upY = e.e.pageY
          this.fillStartPointX = this.fillStartPointX + (this.upX - this.downX)
          this.fillStartPointY = this.fillStartPointY + (this.upY - this.downY)
        } else if (this.CURRENT_MODE === this.COMMENTS_MODE) {
          this.changeMode(this.MOVE_MODE)
        } else if (this.CURRENT_MODE === this.LINE_MODE || this.CURRENT_MODE === this.ARROW_MODE || this.CURRENT_MODE === this.RECT_MODE || this.CURRENT_MODE === this.HIGHLIGHT_MODE) {
          var xy = this.transformMouse(e.e.offsetX, e.e.offsetY)
          this.mouseTo.x = xy.x
          this.mouseTo.y = xy.y
          // drawing();
          this.drawingObject = null
          // moveCount = 1;
          this.doDrawing = false
          this.saveState()
        }
      })
      const removeCanvasItem = (obj) => {
        if (obj.target._objects) {
          // 多选删除
          var etCount = obj.target._objects.length
          for (let etindex = 0; etindex < etCount; etindex++) {
            if (obj.target._objects[etindex].customType === 'tag') {
              this.tagNumList[obj.target._objects[etindex].index] = false
            }
            this.canvas.remove(obj.target._objects[etindex])
          }
        } else {
          // 单选删除
          if (obj.target.customType === 'tag') {
            this.tagNumList[obj.target.index] = false
          }
          this.canvas.remove(obj.target)
        }
        this.canvas.discardActiveObject() // 清除选中框
      }
      this.canvas.on('selection:created', (e) => {
        document.onkeydown = (event) => {
          let keyEvent = event || window.event || arguments.callee.caller.arguments[0]
          if ((keyEvent && keyEvent.keyCode === 8) || (keyEvent && keyEvent.keyCode === 46)) {
            removeCanvasItem(e)
          }
        }
        console.log(e.target)
        console.log('select')
        if (this.CURRENT_MODE === this.ERASER_MODE) {
          removeCanvasItem(e)
          // if (e.target._objects) {
          //   // 多选删除
          //   var etCount = e.target._objects.length
          //   for (let etindex = 0; etindex < etCount; etindex++) {
          //     if (e.target._objects[etindex].type === 'tag') {
          //       this.tagNumList[e.target._objects[etindex].index] = false
          //     }
          //     this.canvas.remove(e.target._objects[etindex])
          //   }
          // } else {
          //   // 单选删除
          //   if (e.target.type === 'tag') {
          //     this.tagNumList[e.target.index] = false
          //   }
          //   this.canvas.remove(e.target)
          // }
          // this.canvas.discardActiveObject() // 清除选中框
        }
        console.log('selection:created')
      })
    },
    save () {
      console.log(this.canvas.toDataURL())
    },
    changeColor (index) {
      switch (this.CURRENT_MODE) {
        case this.LINE_MODE:
          this.lineColorIndex = index
          break
        case this.ARROW_MODE:
          this.arrowColorIndex = index
          break
        case this.RECT_MODE:
          this.rectColorIndex = index
          break
        case this.TAG_MODE:
          this.tagColorIndex = index
          break
        default:
          break
      }
    },
    draw () {
      // var canvas = new fabric.Canvas('canvas', {
      //   isDrawingMode: true
      // })
      this.isDrawingMode = true
      this.canvas.isDrawingMode = this.isDrawingMode
      this.canvas.freeDrawingBrush.color = 'red'
    },
    addTag () {
      this.isDrawingMode = false
      this.canvas.isDrawingMode = this.isDrawingMode
    },
    saveCanvas () {
      this.scaleValue = 1.0
      this.handleZoom(this.scaleValue)
      setTimeout(() => {
        var data = this.canvas.toDataURL('image/jpeg')
        console.log(data)
      }, 1000)
      // this.$nextTick(() => {
      //   var data = this.canvas.toDataURL('image/jpeg')
      //   console.log(data)
      // })
    },
    // 退出批改
    quit () {
      this.$confirm('退出批改将不会保存已经批改的内容，确定退出吗？', '', {
          confirmButtonText: '确定退出',
          cancelButtonText: '继续批改',
          type: 'warning'
        }).then(() => {
        }).catch(() => {
        })
    },
    // 查看 下载附件
    viewAttachment (url) {
      window.open(url)
    }
  },
  created () {
    this.tagNumList = new Array(20).fill(false)
  },
  mounted () {
    this.attachmentListData = attachmentList.answer_part
    console.log('1111111', this.attachmentListData.answer_part)
    this.init()
    // this.fillImageSrc = this.fillImageList[0].originSrc
    // const canvasWidth = window.getComputedStyle(this.$refs.wrap).width.slice(0, -2)
    // const canvasHeight = window.getComputedStyle(this.$refs.wrap).height.slice(0, -2)
    // this.canvas = document.getElementById('canvas')
    // this.context = this.canvas.getContext('2d')

    // this.canvas.width = canvasWidth
    // this.canvas.height = canvasHeight

    // var canvas = new fabric.Canvas('canvas')
    // this.canvas = canvas
    // canvas.setBackgroundImage(
    //   this.fillImageSrc,
    //   canvas.renderAll.bind(canvas),
    //   {
    //     top: 500,
    //     left: 600,
    //     scaleX: 0.6,
    //     scaleY: 0.6,
    //     angle: 90,
    //     originX: 'center',
    //     originY: 'center'
    //   }
    // );
    var rect = new fabric.Rect({
      top: 50,
      left: 100,
      width: 100,
      height: 70,
      stroke: 'red',
      fill: 'transparent'
    })
    // canvas.add(rect)
    var rect1 = new fabric.Rect({
      top: 50,
      left: 100,
      width: 100,
      height: 70,
      fill: 'blue'
    })
    // canvas.add(rect1)
    // var fabric = require('fabric').fabric,
    // canvas = fabric.createCanvasForNode(200, 200);

    // canvas.add(new fabric.Rect({
    //   top: 100,
    //   left: 100,
    //   width: 100,
    //   height: 50,
    //   angle: 30,
    //   fill: 'rgba(255,0,0,0.5)'
    // }));
    var itext = new fabric.IText('输入文字', {
      left: 100,
      top: 150,
      fill: '#D81B60',
      strokeWidth: 2,
      stroke: "#880E4F",
    });

    var textbox = new fabric.Textbox('This is a Textbox object', {
      left: 20,
      top: 50,
      fill: '#880E4F',
      strokeWidth: 2,
      stroke: "#D81B60",
    })
    const arr = [itext, textbox]
    console.log(canvas)
    // canvas.add(itext, textbox)
    arr.forEach((item) => {
      console.log(item)
      // canvas.add(item)
    })
    var path = new fabric.Path('M121.32,0L44.58,0C36.67,0,29.5,3.22,24.31,8.41\
    c-5.19,5.19-8.41,12.37-8.41,20.28c0,15.82,12.87,28.69,28.69,28.69c0,0,4.4,\
    0,7.48,0C36.66,72.78,8.4,101.04,8.4,101.04C2.98,106.45,0,113.66,0,121.32\
    c0,7.66,2.98,14.87,8.4,20.29l0,0c5.42,5.42,12.62,8.4,20.28,8.4c7.66,0,14.87\
    -2.98,20.29-8.4c0,0,28.26-28.25,43.66-43.66c0,3.08,0,7.48,0,7.48c0,15.82,\
    12.87,28.69,28.69,28.69c7.66,0,14.87-2.99,20.29-8.4c5.42-5.42,8.4-12.62,8.4\
    -20.28l0-76.74c0-7.66-2.98-14.87-8.4-20.29C136.19,2.98,128.98,0,121.32,0z');

    // canvas.add(path.set({ left: 100, top: 200 }));
    setTimeout(() => {
      // console.log(canvas.getObjects());
      // canvas.remove(path)
    }, 5000);
    // console.log(canvas.item(0))
    // console.log(canvas.item(4))
    // fabric.Image.fromURL('http://cdn.algbb.cn/test/canvasTest2.png', (img) => {
    //   img.scale(0.5).set({
    //     left: 150,
    //     top: 150,
    //     selectable: false
    //   });
    //   canvas.add(img);
    // });

    // 清空画布
    // setTimeout(() => {
    //   canvas.clear()
    //   canvas.setBackgroundImage(
    //     this.fillImageSrc,
    //     canvas.renderAll.bind(canvas),
    //     {
    //       top: 60,
    //       left: 100,
    //       scaleX: 0.57,
    //       scaleY: 0.57
    //     }
    //   );
    // }, 5000)

    //鼠标按下事件
    // canvas.on("mouse:down", function(e) {
    //   // console.log(e.target)
    //   if (!this.isDrawingMode) {
    //     if (!e.target) {
    //       this.panning = true;
    //       canvas.selection = false;
    //     }
    //   }
    // });
    // // //鼠标抬起事件
    // canvas.on("mouse:up", function(e) {
    //   this.panning = false;
    //   canvas.selection = true;
    // });
    // canvas.on("selection:cleared", function(e) {
    //   console.log('selection:cleared')
    // });
    // canvas.on("selection:created", function(e) {
    //   console.log('selection:created')
    //   setTimeout(() => {
    //     console.log(canvas.getObjects());
    //     canvas.remove(e.target)
    //     console.log(canvas.getObjects());
    //   }, 2000);
    // });
    // canvas.on("selection:updated", function(e) {
    //   console.log('selection:updated')
    // });
    // // // 移动画布事件
    // canvas.on("mouse:move", function(e) {
    //   if (!this.isDrawingMode) {
    //     if (this.panning && e && e.e) {
    //       var delta = new fabric.Point(e.e.movementX, e.e.movementY);
    //       canvas.relativePan(delta);
    //     }
    //   }
    // });
    // // 鼠标滚动放大缩小画布
    // //
    // if (document.getElementById("canvas")) {
    //   // IE9, Chrome, Safari, Opera
    //   document.addEventListener("mousewheel", function(e) {
    //     if (e.target.className == "upper-canvas ") {
    //       var zoom = (event.deltaY > 0 ? -0.1 : 0.1) + canvas.getZoom();
    //       zoom = Math.max(0.1, zoom); //最小为原来的1/10
    //       zoom = Math.min(3, zoom); //最大是原来的3倍
    //       var zoomPoint = new fabric.Point(event.pageX, event.pageY);
    //       canvas.zoomToPoint(zoomPoint, zoom);
    //     }
    //   });
    // }
  }
}
</script>

<style lang="less" scoped>
.mark-paper{
  height: 100%;
  min-width: 880px;
}
.mark-paper{
  &__header{
    overflow: hidden;
    height: 59px;
    line-height: 59px;
    box-shadow: 0px 1px 0px 0px	#e5e5e5;
    background-color: #ffffff;
    padding: 0px 20px;
    .title{
      float: left;
      font-size: 16px;
      font-weight: bold;
      color: #2a2e3d;
    }
    .buttons{
      float: right;
    }
  }
  &__container{
    display: flex;
    height: calc(100% - 59px);
  }
  &__thumb{
    flex: 0 0 130px;
    height: 100%;
    background-color: #f2f2f2;
    border-right: 1px solid #cccbcb        ;
    // overflow: auto;
    ul{
      list-style: none;
      padding: 0;
      margin:6px 0 0 0;
      li{
        padding: 5px 10px 5px 0;
        width: 100%;
        overflow: hidden;
        cursor: pointer;
        text-align: center;
        display: flex;
        align-items: flex-end;
        &.active{
          background-color: #6594fe;
        }
        // justify-content:center;
        span{
          display: inline-block;
          &.order{
            font-size: 12px;
            color: #838c96;
            padding-left: 11px;
            padding-right: 5px;
            &.active{
              color: #ffffff;
            }
          }
          &.thumb__img{
            width: 96px;
            height: 72px;
            overflow: hidden;
            background-color: #ffffff;
            box-shadow: 0px 0px 5px 0px rgba(229, 229, 229, 0.5);
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content:center;
            img{
              max-width: 100%;
            }
          }
        }
      }
    }
  }
  &__scroll{
    height: 100%;
    .el-scrollbar__wrap{
      // overflow-x: hidden;
      overflow-y: auto;
    }
  }
  &__wrap{
    flex:1;
    background-color: #e0e0e0;
    position: relative;
    overflow: hidden;
    .canvas__wrap{
      position: absolute;
      left: 50%;
      margin-left: -375px;
      width: 750px;
      height: 1334px;
      overflow: hidden;
      // margin: auto;
      background: #ffffff;
    }
    .tools{
      position: absolute;
      left: 0;
      top: 42px;
      height: 50px;
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content:center;
      span{
        cursor: pointer;
      }
      .scale_canvas{
        width: 80px;
        height: 100%;
        position: relative;
        margin: 0 10px;
        .el-input__inner{
          height: 30px!important;
        }
        .tag{
          position: absolute;
          top: 33px;
          left: 50%;
          margin-left: -10px;
          font-size: 14px;
          color: #2a2e3d;
        }
      }
      .tools_box{
        height: 32px;
        text-align: center;
        border-radius: 4px;
        margin: 0 10px;
        border: solid 1px #e5e5e5;
        span{
          width: 50px;
          height: 30px;
          float: left;
          i{
            display: block;
            width: 50px;
            font-style: normal;
            &.icon{
              height: 30px;
              background-color: #ffffff;
              background-repeat: no-repeat;
              background-position: center;
              &.move{
                background-image: url('./img/move.png');
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/move_on.png');
                }
              }
              &.paint{
                background-image: url('./img/paint.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/paint_on.png');
                }
              }
              &.eraser{
                background-image: url('./img/eraser.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/eraser_on.png');
                }
              }
              &.line{
                background-image: url('./img/line.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/line_on.png');
                }
              }
              &.arrow{
                background-image: url('./img/arrow.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/arrow_on.png');
                }
              }
              &.rect{
                background-image: url('./img/rect.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/rect_on.png');
                }
              }
              &.tag{
                background-image: url('./img/tag.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/tag_on.png');
                }
              }
              &.highlight{
                background-image: url('./img/highlight.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/highlight_on.png');
                }
              }
              &.comments{
                background-image: url('./img/comments.png');
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                &:hover, &.active{
                  background-image: url('./img/comments_on.png');
                }
              }
            }
            &.tag{
              display: block;
              text-align: center;
              font-size: 14px;
              color: #2a2e3d;
              padding-top: 2px;
            }
          }
        }
      }
      .handle_box{
        height: 32px;
        text-align: center;
        border-radius: 4px;
        border: solid 1px #e5e5e5;
        margin: 0 10px;
        span{
          width: 50px;
          height: 30px;
          float: left;
          &:last-child{
            width: 60px;
            i{
              width: 60px;
            }
          }
          i{
            display: block;
            width: 50px;
            font-style: normal;
            &.icon{
              height: 30px;
              background-color: #ffffff;
              background-repeat: no-repeat;
              background-position: center;
              &.rotate{
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
                background-image: url('./img/rotate.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/rotate_on.png');
                }
              }
              &.cancel{
                background-image: url('./img/cancel.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/cancel_on.png');
                }
              }
              &.clear{
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                background-image: url('./img/clear.png');
                &:hover, &.active{
                  background-image: url('./img/clear_on.png');
                }
              }
            }
            &.tag{
              display: block;
              text-align: center;
              font-size: 14px;
              color: #2a2e3d;
              padding-top: 2px;
            }
          }
        }
      }
    }
    .attachments{
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -375px;
      width: 750px;
      height: 60px;
      line-height: 60px;
      font-weight: bold;
      background: rgba(0,0,0, 0.2);
      overflow: hidden;
      .left{
        float: left;
        .attachmentIcon{
          width: 24px;
          height: 24px;
          background-color: #fafafa;
          border-radius: 4px;
          border: solid 1px #e6e7e8;
          background-position: center;
          background-repeat: no-repeat;
          display: inline-block;
          cursor: pointer;
          margin-left: 10px;
          position: relative;
          top: 7px;
          &.pic{
            background-image: url("./img/attach/pic.png");
            &:hover{
              background-image: url("./img/attach/pic_on.png");
            }
          }
          &.video{
            background-image: url("./img/attach/video.png");
            &:hover{
              background-image: url("./img/attach/video_on.png");
            }
          }
          &.audio{
            background-image: url("./img/attach/audio.png");
            &:hover{
              background-image: url("./img/attach/audio_on.png");
            }
          }
          &.word{
            background-image: url("./img/attach/word.png");
            &:hover{
              background-image: url("./img/attach/word_on.png");
            }
          }
          &.excel{
            background-image: url("./img/attach/excel.png");
            &:hover{
              background-image: url("./img/attach/excel_on.png");
            }
          }
          &.pdf{
            background-image: url("./img/attach/pdf.png");
            &:hover{
              background-image: url("./img/attach/pdf_on.png");
            }
          }
          &.other{
            background-image: url("./img/attach/other.png");
            &:hover{
              background-image: url("./img/attach/other_on.png");
            }
          }
        }
      }
      .attachments-title{
        margin-left: 30px;
      }
    }
  }
}
.colors{
  list-style-type: none;
  padding: 0;
  margin: 0;
  overflow: hidden;
  li{
    width: 20px;
    height: 20px;
    border: 1px solid #cccccc;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    margin: 0 2px;
    &:hover, &.active{
      border: 1px solid #000000;
    }
    span{
      display: block;
      width: 16px;
      height: 16px;
      padding: 1px;
      background: red;
    }
  }
}

  canvas {
      // border: 1px dashed black;
  }
</style>



// WEBPACK FOOTER //
// src/pages/mark-paper/copy.vue